<template>
  <div id="app" :class="['app ' + $route.name]">
    <transition name="fade">
      <div id="page" class="page" v-if="pageLoaded">
        <Header :static-pages="textPageList" />
        <router-view
          :currencies="currencies"
          :crypto="crypto"
          :rates="rates"
          @orderSubmit="orderSubmit"
          @setCheckoutData="setCheckoutData"
          @setWallet="setWallet"
          @setSenderFullName="setSederFullName"
          @setBankName="setBankName"
          @setIban="setIban"
          @logout="logout"
        />
        <Footer />
        <transition name="fade">
          <SignInModal
            v-if="signInModalIsVisible"
            @closeSignInModal="closeSignInModal"
            @login="login"
          />
        </transition>
        <transition name="fade">
          <TwoFactorModal
            v-if="show2FAModal"
            @close="closeAuth2FAModal"
            @verify="loginWith2FA"
            :mode="'verifyLogin'"
          />
        </transition>
        <transition name="fade">
          <RequestPasswordRestoreModal
            v-if="recoverModalIsVisible"
            @closeRecover="closeRecover"
            @forgotPass="forgotPass"
          />
        </transition>
        <transition name="fade">
          <PasswordRestoreModal
            v-if="restoreModalIsVisible"
            @closeRestore="closeRestore"
            @forgotPass="forgotPass"
          />
        </transition>
        <transition name="fade">
          <RegisterModal
            v-if="registerModalIsVisible"
            @closeRegister="closeRegister"
            @registration="registration"
          />
        </transition>
        <transition name="fade">
          <PersonalInfoModal
            v-if="personalInfoModalIsVisible"
            @closePersonalInfoModal="closePersonalInfoModal"
            @orderSubmit="orderSubmit"
            @setPersonalInfo="setPersonalInfo"
          />
        </transition>
        <cookie-modal></cookie-modal>
      </div>
    </transition>
  </div>
</template>

<script>
import CookieModal from "./components/CookieModal.vue";
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
import SignInModal from "./components/SignInModal.vue";
import TwoFactorModal from "./components/TwoFactorModal.vue";
import RequestPasswordRestoreModal from "./components/RequestPasswordRestoreModal.vue";
import PasswordRestoreModal from "./components/PasswordRestoreModal.vue";
import RegisterModal from "./components/RegisterModal.vue";
import PersonalInfoModal from "./components/PersonalInfoModal.vue";
import { mapActions } from "vuex";
import { loadScriptsFromString } from "@/utils/load_scripts";

export default {
  name: "app",
  components: {
    Header,
    Footer,
    SignInModal,
    TwoFactorModal,
    RequestPasswordRestoreModal,
    RegisterModal,
    PersonalInfoModal,
    CookieModal,
    PasswordRestoreModal,
  },
  data: function () {
    return {
      pageLoaded: false,
      headerNav: [
        {
          title: "Home",
          path: "/",
        },
        {
          title: "Buy Crypto",
          path: "/buy-crypto",
        },
        // {
        //   title: 'About us',
        //   path: '/about-us'
        // }
      ],
      footerNav: [
        {
          title: "FAQ’s",
          path: "/faq",
        },
      ],
      signInModalIsVisible: false,
      registerModalIsVisible: false,
      recoverModalIsVisible: false,
      restoreModalIsVisible: false,
      show2FAModal: false,
      tempLoginData: null,
      error: "",
      isAuth: false,
      emailVerified: false,
      successMessage: "",
      currencies: {},
      crypto: {},
      rates: [],
      wallets: [],
      orderHistory: [],
      giveAmount: 0,
      takeAmount: 0,
      takeCurrency: {},
      giveCurrency: "",
      paymentMethod: "",
      orderDateTime: null,
      fiatToCrypto: true,
      personalInfoModalIsVisible: false,
      wallet: "",
      senderFullName: "",
      bankName: "",
      iban: "",
      phone: "",
      countryId: "",
      city: "",
      address: "",
      postCode: "",
      birthDate: "",
      name: "",
      surname: "",
      email: "",
      faq: [],
      textPageList: [],
      socialLinks: [],
      hostname: "",
      textPageTitle: "",
      textPageHeader: "",
      textPageContent: "",
      checkoutSuccess: false,
      companyEmail: "",
      companyPhone: "",
      billingDescriptor: "",
      minOrderPriceFiatToCrypto: null,
      minOrderPriceCryptoToFiat: null,
      legalInfo: "",
    };
  },
  watch: {
    $route() {
      window.scrollTo(0, 0);
    },
  },
  methods: {
    checkAuthStatus() {
      const self = this;

      this.$http
        .get(process.env.VUE_APP_API + "is-auth")
        .then((res) => {
          this.isAuth = res.data.authenticated;
          this.emailVerified = !!res.data.emailVerified;

          if (this.emailVerified) {
            self.fetchProfile();
          }

          localStorage.setItem("isAuthenticated", this.isAuth.toString());
          localStorage.setItem("emailVerified", this.emailVerified.toString());

          if (!this.isAuth && this.$route.name === "OrderRequisites") {
            this.$router.push({
              name: "Home",
              query: { redirect: this.$route.path },
            });
          } else if (this.isAuth && !this.emailVerified) {
            // this.$router.push({ name: 'EmailVerificationNotice' });
          }
        })
        .catch(() => {});
    },
    getDomainName(hostName) {
      return hostName.substring(
        hostName.lastIndexOf(".", hostName.lastIndexOf(".") - 1) + 1
      );
    },
    clearError() {
      this.error = "";
    },
    openSignInModal() {
      this.registerModalIsVisible = false;
      this.recoverModalIsVisible = false;
      this.signInModalIsVisible = true;
    },
    closeSignInModal() {
      this.signInModalIsVisible = false;
      this.tempLoginData = null;
      this.clearError();
    },
    closeAuth2FAModal() {
      this.show2FAModal = false;
      this.tempLoginData = null;
      this.clearError();
    },
    openRecover() {
      this.signInModalIsVisible = false;
      this.registerModalIsVisible = false;
      this.recoverModalIsVisible = true;
    },
    closeRecover() {
      this.recoverModalIsVisible = false;
      this.clearError();
    },
    closeRestore() {
      this.restoreModalIsVisible = false;
      this.clearError();
    },
    openRegister() {
      this.signInModalIsVisible = false;
      this.recoverModalIsVisible = false;
      this.registerModalIsVisible = true;
    },
    closeRegister() {
      this.registerModalIsVisible = false;
      this.clearError();
    },
    loginWith2FA(code) {
      const loginData = {
        ...this.tempLoginData,
        two_factor_code: code,
      };
      this.login(loginData);
    },
    login(data) {
      let self = this;
      this.$store.commit('twoFactor/SET_ERROR', null);

      self.$http
        .get(process.env.VUE_APP_SANCTUM + "sanctum/csrf-cookie")
        .then(() => {
          self.$http
            .post(process.env.VUE_APP_API + "login", data)
            .then((res) => {
              if (res.data.status == "OK") {
                const emailVerified = !!res.data.email_verified;

                if (emailVerified) {
                  self.fetchProfile();
                }

                self.isAuth = true;
                localStorage.setItem("isAuthenticated", true.toString());
                localStorage.setItem("authToken", res.data.access_token);
                localStorage.setItem("emailVerified", emailVerified);
                self.clearError();
                self.closeSignInModal();
                self.closeAuth2FAModal();

                if (this.$route.query["redirect"]) {
                  self.$router.push({ path: self.$route.query["redirect"] });
                } else {
                  self.$router.push({ path: "/buy-crypto" });
                }
              } else if (res.data.status == "REQUIRES_2FA") {
                self.tempLoginData = data;
                self.signInModalIsVisible = false;
                // Store the can_show_qr flag for stuck users
                self.$store.commit('twoFactor/SET_CAN_SHOW_QR', res.data.can_show_qr || false);
                self.show2FAModal = true;
              } else if (res.data.status == "REQUIRES_2FA_SETUP") {
                self.tempLoginData = data;
                self.signInModalIsVisible = false;
                self.$store.commit('twoFactor/SET_QR_CODE', res.data.qr);
                self.$store.commit('twoFactor/SET_SETUP_MODE', true);
                self.$store.commit('twoFactor/SET_SETUP_STEP', 'qr');
                self.show2FAModal = true;
              } else {
                self.error = res.data.message;
              }
            })
            .catch((err) => {
              const errorMessage = err.response.data.message;
              if (this.show2FAModal) {
                  this.$store.commit('twoFactor/SET_ERROR', errorMessage);
              } else {
                  self.error = errorMessage;
              }
              
              this.isAuth = false;
              localStorage.setItem("isAuthenticated", false.toString());
              localStorage.setItem("emailVerified", false.toString());
              localStorage.removeItem("authToken");
            });
        });
    },
    registration(data) {
      let self = this;
      if (data.password !== data.passConfirm) {
        self.error = "Password confirmation failed!";
      } else {
        self.$http
          .post(process.env.VUE_APP_API + "register", data)
          .then((res) => {
            if (res.data.status == "OK") {
              self.clearError();
              self.isAuth = true;
              localStorage.setItem("isAuthenticated", true.toString());
              localStorage.setItem("authToken", res.data.access_token);
              localStorage.setItem("emailVerified", false);

              self.closeRegister();

              if (this.$route.query["redirect"]) {
                self.$router.push({ path: self.$route.query["redirect"] });
              } else {
                self.$router.push({ path: "/profile" });
              }
            } else {
              self.error = res.data.message;
            }
          })
          .catch((res) => {
            this.error = res.response.data.message;
          });
      }
    },
    forgotPass(data) {
      let self = this;
      this.$http
        .post(process.env.VUE_APP_API + "user/reset-password", data)
        .then((res) => {
          if (res.data.status == "OK") {
            this.successMessage = "Success";
            this.error = "";
            setTimeout(() => {
              self.successMessage = "";
            }, 2000);
          } else {
            this.error = res.response.data.message;
          }
        })
        .catch((error) => {
          this.error = error.response.data.message;
        });
    },

    logout() {
      this.$http
        .post(process.env.VUE_APP_API + "logout")
        .then(() => {
          this.isAuth = false;
          localStorage.removeItem("authToken");
          localStorage.setItem("isAuthenticated", false.toString());
          localStorage.setItem("emailVerified", false.toString());

          // Reset 2FA store state on logout
          this.$store.dispatch('twoFactor/logout');

          this.$router.push({ path: "/" });
          this.openSignInModal();
        })
        .catch(() => {});
    },
    getOrderHistory() {
      this.$http
        .get(process.env.VUE_APP_API + "orders/history")
        .then((res) => {
          this.orderHistory = res.data.payload;
        })
        .catch(() => {});
    },
    async getCurrencies() {
      return this.$http
        .get(process.env.VUE_APP_API + "currencies-data")
        .then((res) => {
          this.currencies = res.data.currencies;
          this.crypto = res.data.crypto;
          this.rates = res.data.rates;
          this.wallets = res.data.wallets;
        })
        .catch(() => {});
    },
    setCheckoutData(
      giveAmount,
      takeAmount,
      takeCurrency,
      giveCurrency,
      paymentMethod,
      fiatToCrypto,
      orderDateTime
    ) {
      this.giveAmount = giveAmount;
      this.takeAmount = takeAmount;
      this.takeCurrency = takeCurrency;
      this.giveCurrency = giveCurrency;
      this.paymentMethod = paymentMethod;
      this.fiatToCrypto = fiatToCrypto;
      this.orderDateTime = orderDateTime;
    },
    orderSubmit() {
      let data = {
        paymentType: this.paymentMethod,
        source_asset: this.fiatToCrypto
          ? this.takeCurrency.currency
          : this.takeCurrency.crypto_currency,
        dest_asset: this.fiatToCrypto
          ? this.takeCurrency.crypto_currency
          : this.takeCurrency.currency,
        amount: this.fiatToCrypto ? this.giveAmount : this.takeAmount,
        exchange_rate: this.takeCurrency.price,
        wallet: this.wallet,
      };

      const fiatToCrypto = this.fiatToCrypto;

      if (!fiatToCrypto) {
        data = {
          ...data,
          sender_full_name: this.senderFullName,
          bank_name: this.bankName,
          iban: this.iban,
        };
      }

      this.$http
        .post(process.env.VUE_APP_API + "orders/checkout", data)
        .then((res) => {
          if (res.data.redirect_url) {
            window.location = res.data.redirect_url;
          } else {
            this.changeCheckoutSuccess(true);
            this.closePersonalInfoModal();

            if (!fiatToCrypto && res.data.uuid)
              this.$router.push({
                name: "OrderDetails",
                params: { id: res.data.uuid },
              });
          }
        })
        .catch((res) => {
          this.error = res.response.data.message;
        });
    },
    openPersonalInfoModal() {
      this.personalInfoModalIsVisible = true;
    },
    closePersonalInfoModal() {
      this.personalInfoModalIsVisible = false;
      this.clearError();
    },
    setPersonalInfo(
      email,
      name,
      surname,
      phone,
      postCode,
      countryId,
      city,
      address,
      birthDate
    ) {
      this.email = email;
      this.name = name;
      this.surname = surname;
      this.phone = phone;
      this.countryId = countryId;
      this.city = city;
      this.address = address;
      this.postCode = postCode;
      this.birthDate = birthDate;
    },
    setWallet(wallet) {
      this.wallet = wallet;
    },
    setSederFullName(fullName) {
      this.senderFullName = fullName;
    },
    setBankName(bankName) {
      this.bankName = bankName;
    },
    setIban(iban) {
      this.iban = iban;
    },
    goToPrivacy() {
      this.closePersonalInfoModal();
      this.closeRegister();
      for (let i = 0; i < this.textPageList.length; i++) {
        if (this.textPageList[i].is_privacy) {
          const page = this.textPageList[i];
          const target = page.slug || page.id;
          this.$router.push({
            path: page.slug ? "/" + page.slug : "/pages/" + page.id,
            params: { data: target },
          });
          this.getTextPageContent(target);
        }
      }
    },
    goToTerms() {
      this.closePersonalInfoModal();
      this.closeRegister();
      for (let i = 0; i < this.textPageList.length; i++) {
        if (this.textPageList[i].is_terms) {
          const page = this.textPageList[i];
          const target = page.slug || page.id;
          this.$router.push({
            path: page.slug ? "/" + page.slug : "/pages/" + page.id,
            params: { data: target },
          });
          this.getTextPageContent(target);
        }
      }
    },
    goToAllowedCountries() {
      this.closePersonalInfoModal();
      this.closeRegister();
      for (let i = 0; i < this.textPageList.length; i++) {
        if (this.textPageList[i].is_countries) {
          const page = this.textPageList[i];
          const target = page.slug || page.id;
          this.$router.push({
            path: page.slug ? "/" + page.slug : "/pages/" + page.id,
            params: { data: target },
          });
          this.getTextPageContent(target);
        }
      }
    },
    goToPage(item) {
      this.closePersonalInfoModal();
      this.closeRegister();
      const target = item.slug || item.id;
      this.$router.push({
        path: item.slug ? "/" + item.slug : "/pages/" + item.id,
        params: { data: target },
      });
      this.getTextPageContent(target);
    },
    goToCookiesPage() {
      this.closePersonalInfoModal();
      this.closeRegister();
      // Prefer a slugged cookie page if we can find it by title, else fallback to legacy ID 7
      const cookie = this.textPageList.find(
        (p) => p.title && p.title.toLowerCase().includes("cookie")
      );
      if (cookie) {
        const target = cookie.slug || cookie.id;
        this.$router.push({
          path: cookie.slug ? "/" + cookie.slug : "/pages/" + cookie.id,
          params: { data: target },
        });
        this.getTextPageContent(target);
      } else {
        this.$router.push({ path: "/pages/" + 7, params: { data: 7 } });
        this.getTextPageContent(7);
      }
    },
    getTextPageContent(id) {
      this.textPageTitle = "";
      this.textPageHeader = "";
      this.textPageContent = "";
      this.$http
        .get(process.env.VUE_APP_API + "static-pages/" + id)
        .then((res) => {
          this.textPageTitle = res.data.payload.title;
          this.textPageContent = res.data.payload.content;
          this.textPageHeader = res.data.payload.header;
        })
        .catch((res) => {
          if (res.response) {
            if (res.response.status === 401) {
              this.openSignInModal();
            } else if (res.response.status === 404) {
              this.$router.replace({ name: "PageNotFound" });
            }
          }
        });
    },
    getTextPages() {
      this.$http
        .get(process.env.VUE_APP_API + "static-pages")
        .then((res) => {
          this.textPageList = res.data.payload;
        })
        .catch(() => {});
    },
    getFaq() {
      this.$http
        .get(process.env.VUE_APP_API + "faq")
        .then((res) => {
          this.faq = res.data.payload;
        })
        .catch(() => {});
    },
    toExchange(giveAmount, takeAmount, chosenCrypto) {
      this.giveAmount = giveAmount;
      this.takeAmount = takeAmount;
      this.takeCurrency = chosenCrypto;
      this.$router.push({ path: "/buy-crypto" });
    },
    getGoogleTagManagerSnippet() {
      this.$http
        .get(process.env.VUE_APP_API + "settings")
        .then((res) => {
          const payload = res.data.payload;

          this.legalInfo = res.data.payload.legal_info;
          this.companyEmail = res.data.payload.support_email;
          this.companyPhone = res.data.payload.support_phone;
          this.billingDescriptor = res.data.payload.billing_descriptor;
          this.minOrderPriceFiatToCrypto = payload.min_order_fiat_to_crypto
            ? parseFloat(payload.min_order_fiat_to_crypto)
            : null;
          this.minOrderPriceCryptoToFiat = payload.min_order_crypto_to_fiat
            ? parseFloat(payload.min_order_crypto_to_fiat)
            : null;

          const snippet = res.data.payload.google_analytics;

          if (snippet) {
            loadScriptsFromString(snippet);
          }
        })
        .catch((error) => {
          console.error("Error fetching Google Tag Manager snippet:", error);
        });
    },
    getSocialLinks() {
      this.$http
        .get(process.env.VUE_APP_API + "social-links")
        .then(({ data }) => {
          this.socialLinks = data.payload;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    changeCheckoutSuccess(value) {
      this.checkoutSuccess = value;
    },
    ...mapActions("user", ["fetchProfile"]),
  },
  created() {
    const authToken = localStorage.getItem("authToken");
    if (authToken) {
      this.isAuth = true;
    }
  },
  mounted: async function () {
    this.restoreModalIsVisible = this.$route.name === "PasswordRestore";
    this.getGoogleTagManagerSnippet();
    this.getSocialLinks();
    this.currency = process.env.VUE_APP_CURRENCY;
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
    this.pageLoaded = true;

    this.hostname = this.getDomainName(window.location.hostname);
    this.getFaq();
    this.getTextPages();

    await this.checkAuthStatus();

    if (this.isAuth || localStorage.getItem("authToken")) {
      this.getOrderHistory();
    }
    await this.getCurrencies();
  },
  computed: {},
};
</script>